import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { NAME } from './constants';
import * as actionTypes from './actionTypes';

const initialState = {
    token: null,
    authModel: null,
    authorizing: false,
    paramsToken: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTHORIZE_BY_APPLICATION.REQUEST:
            return {
                ...state,
                authorizing: true,
                paramsToken: action.payload
            };
        case actionTypes.AUTHORIZE_BY_APPLICATION.SUCCESS:
            return {
                ...state,
                authModel: action.payload,
                token: action.payload.token,
                authorizing: false
            };
        case actionTypes.AUTHORIZE_BY_APPLICATION.ERROR:
            return {
                ...state,
                authorizing: false
            };
        default:
            return state;
    }
};

const persistConfig = {
    key: NAME,
    storage,
    whitelist: ['token', 'authModel', 'paramsToken']
};

export default persistReducer(persistConfig, reducer);